var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"m-icon",class:!_vm.isImage ? 'm-icon-' + _vm.name : '',style:(_vm.styles),on:{"click":_vm.onClick}},[(_vm.isImage)?_c('img',{staticClass:"icon__image",style:(_vm.imageStyles),attrs:{"src":_vm.name}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }